import React, {
  useState,
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
} from "react";
import { Checkbox, Input } from "sr/helpers";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormik } from "formik";
import { jobtypeSchema } from "sr/utils/schemas/cleaner/jobtypeSchema";
import { createJobtype } from "sr/utils/api/cleaner/createJobtype";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { CleanerComponentProps } from "./CleanerComponentProps";
import { getJobType } from "sr/utils/api/cleaner/getJobType";
import { updateJobType } from "sr/utils/api/cleaner/updateJobType";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { ReactSelect } from "sr/helpers/ui-components/ReactSelect";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import { toast } from "react-toastify";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { deleteJobType } from "sr/utils/api/cleaner/deleteJobType";
import { Pageination } from "sr/helpers/ui-components/Pageination";
import { createIndIntersted } from "sr/utils/api/cleaner/indInterested/createIndIntersted";
import { getIndIntersted } from "sr/utils/api/cleaner/indInterested/getIndIntersted";
import { useNavigate } from "react-router-dom";
import { renderRequiredLabel } from "sr/utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";

const JobType: ForwardRefRenderFunction<any, CleanerComponentProps> = (
  {
    HandleStepper = null,
    page = "",
    type = "",
    dataAddedHandle = null,
    id = "",
  },
  ref
) => {
  const navigate = useNavigate();
  const [AddMoreClicked, setAddMoreClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  const intl = useIntl();
  const jobTypeLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.JOBTYPE.TITLE",
      defaultMessage: "Job Type",
    })
  );
  const hourlyRateLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.JOBTYPE.RATE",
      defaultMessage: "Hourly Rate",
    })
  );
  const [buttonLoader, setButtonLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [jobType, setJobType] = useState<[]>();
  const [rate, setRate] = useState<string>();
  const [information, setInformation] = useState<string>();
  const [alljobs, setAllJobs] = useState(true);
  const [sameRate, setSameRate] = useState(true);
  const [multiJobType, setMultiJobType] = useState([]);
  const [data, setData] = useState(null);
  const [jobPage, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, settotalPage] = useState<number>(0);
  const [checked, setChecked] = useState<string[]>([]);
  const [checkedInitialized, setCheckedInitialized] = useState(false);
  const [multiJobTypeErrors, setMultiJobTypeErrors] = useState<
    Record<string, string>
  >({});
  const [resInterested, setResInterested] = useState(true);
  const [editingJobTypeId, setEditingJobTypeId] = useState("");

  useEffect(() => {
    const getdetails = getUserDetails();
    setUserData(getdetails);
  }, []);
  const initialValues = {
    cleaner_id: userData?.user_id,
    job_type: jobType,
    rate: rate,
    additional_information: information,
  };
  const initialValuesPut = {
    cleaner_id: userData?.user_id,
    job_type: jobType,
    rate: rate,
    additional_information: information,
    id: id,
  };

  const getInterested = async (cleaner_id) => {
    const queryParams = new URLSearchParams();
    queryParams.append("cleaner_id", cleaner_id);
    const res = await getIndIntersted(queryParams);
    if (res?.success === true) {
      setResInterested(res?.data?.interested);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        const result = await getJobType(undefined, id);
        if (result.success === true) {
          setJobType(result?.data?.job_type[0]);

          setRate(result?.data?.rate);
          setInformation(result?.data?.additional_information);
          setLoader(false);
        }
      } catch (e: any) {
        setLoader(false);
      }
    };
    if (page === "popup" && type === "put") {
      fetchData();
    }
  }, [id, page, type]);
  const { handleSubmit, errors, values } = useFormik({
    initialValues:
      page === "popup" && type === "put" ? initialValuesPut : initialValues,
    enableReinitialize: true,
    onSubmit: async (values, helpers) => {
      try {
        setButtonLoader(true);
        let result;

        if (page === "popup" && type === "put") {
          result = await updateJobType(values);
        } else if (editingJobTypeId) {
          result = await updateJobType({
            ...values,
            id: editingJobTypeId,
          });
        } else {
          result = await createJobtype(values);
        }

        if (result?.success === true) {
          setButtonLoader(false);
          if (page === "popup") {
            dataAddedHandle(true);
          }
          if (AddMoreClicked) {
            setJobType([]);
            setRate("");
            setInformation("");
            setAddMoreClicked(false);
            fetchJobTypeData(userData?.user_id);
          } else if (editingJobTypeId) {
            setEditingJobTypeId("");
            setJobType([]);
            setRate("");
            setInformation("");
            setAllJobs(false);
            fetchAllJobTypes(userData?.user_id, 1);
          } else {
            if (HandleStepper !== null) {
              HandleStepper(6);
            }
          }
        } else {
          setLoader(false);
          setButtonLoader(false);
        }
      } catch (e) {
        setLoader(false);
        setButtonLoader(false);
      }
    },
    validationSchema: jobtypeSchema,
  });
  const submitForm = async () => {
    const payload = {
      cleaner_id: userData?.user_id,
      interested: resInterested,
    };
    const result = await createIndIntersted(payload);
    if (result?.success === true) {
      if (resInterested === false) {
        setButtonLoader(true);
        const existingJobTypes = await getJobType(
          userData?.user_id,
          undefined,
          1,
          1000
        );
        if (!existingJobTypes && userData?.user_id) {
          setButtonLoader(false);
          toast.error("Failed to load saved job types.");
          return;
        }

        const existingJobTypeIds: string[] = (existingJobTypes?.data || [])
          .map((item) => item?.id)
          .filter((item): item is string => Boolean(item));

        const deleteResult =
          existingJobTypeIds.length > 0
            ? await deleteJobType({ ids: existingJobTypeIds })
            : { success: true };

        setButtonLoader(false);

        if (!deleteResult?.success) {
          toast.error("Failed to clear saved job types.");
          return;
        }

        if (page === "popup") {
          if (dataAddedHandle) dataAddedHandle(true);
          return;
        } else {
          navigate("/cleaner-jobs");
          return;
        }
      }
    }

    if (alljobs) {
      saveMultipleJobs();
    } else if (type === "edit-multiple") {
      AddAndUpdateJobType();
    } else {
      handleSubmit();
    }
  };
  React.useImperativeHandle(ref, () => ({
    submitForm,
  }));
  const [jobTypes, setJobTypes] = useState([]);
  useEffect(() => {
    const fetchJobType = async () => {
      try {
        const res = await getJobTypeCategory();
        if (res?.success === true) {
          setJobTypes(res?.data);
        }
      } catch (e: any) {}
    };
    fetchJobType();
  }, []);
  const options = jobTypes?.map((item) => ({
    value: item?.value, // Assuming `value` exists
    label: <FormattedMessage id={item?.label} />,
  }));
  const resolveJobTypeValue = (value = "") => {
    if (!value) return "";

    const normalizedValue = value.toLowerCase().trim();
    const matchedJobType = jobTypes?.find((item) => {
      const optionValue = item?.value?.toLowerCase?.().trim();
      const optionLabel = item?.label?.toLowerCase?.().trim();
      const optionTitle = item?.title?.toLowerCase?.().trim();

      return [optionValue, optionLabel, optionTitle].includes(normalizedValue);
    });

    return matchedJobType?.value || value;
  };
  const selectedJobTypeOption =
    options?.find((item) => item?.value === jobType) ||
    (jobType
      ? {
          value: jobType,
          label: jobType,
        }
      : null);
  const selectOptions = selectedJobTypeOption
    ? [
        selectedJobTypeOption,
        ...(options || []).filter((item) => item?.value !== jobType),
      ]
    : options;
  const getJobTypeDisplayLabel = (value) => {
    const label = getLabelByValue(value, jobTypes);

    if (!label || ["Unknown", "Incorrect", "WRONG"].includes(label)) {
      return value || "-";
    }

    return <FormattedMessage id={label} />;
  };

  const resetJobTypeForm = () => {
    setEditingJobTypeId("");
    setJobType([]);
    setRate("");
    setInformation("");
    setAllJobs(false);
    setSameRate(true);
  };
  const handleEditSavedJobType = (item) => {
    setEditingJobTypeId(item?.id);
    setAllJobs(false);
    setSameRate(true);
    setJobType(resolveJobTypeValue(item?.job_type?.[0] || ""));
    setRate(String(item?.rate ?? 0));
    setInformation(item?.additional_information || "");
    setAddMoreClicked(false);
  };
  const handleDeleteSavedJobType = async (item) => {
    if (!item?.id) return;

    setButtonLoader(true);
    const result = await deleteJobType({ id: item.id });
    setButtonLoader(false);

    if (result?.success === true) {
      if (editingJobTypeId === item.id) {
        resetJobTypeForm();
      }
      fetchAllJobTypes(userData?.user_id, 1);
    }
  };
  const saveMultipleJobs = async () => {
    setButtonLoader(true);
    let payload;
    if (sameRate && alljobs) {
      if (!rate) {
        toast.error("Please Enter Rate");
        setButtonLoader(false);
        return;
      }
      payload = jobTypes?.map((item) => {
        return {
          cleaner_id: userData?.user_id,
          job_type: item?.value,
          rate: rate,
          additional_information: information,
        };
      });
    }
    if (alljobs && !sameRate) {
      payload = [...multiJobType];
    }

    const res = await createJobtype(payload);
    if (res?.success === true) {
      if (page === "popup") {
        dataAddedHandle(true);
      }
      if (HandleStepper !== null) {
        HandleStepper(6);
      }
      setButtonLoader(false);
      setMultiJobType([]);
    }
  };
  const fetchJobTypeData = async (cleanerId) => {
    setButtonLoader(true);
    try {
      const jobTypeData = await getJobType(
        cleanerId,
        undefined,
        jobPage,
        limit
      );

      if (jobTypeData?.success) {
        setData(jobTypeData.data);
        setButtonLoader(false);
        return jobTypeData.data;
      } else {
        setButtonLoader(false);
      }
    } catch (e) {
      setButtonLoader(false);
    }
  };

  const fetchAllJobTypes = async (cleanerId, pageNumber = jobPage) => {
    setButtonLoader(true);
    try {
      const jobTypeData = await getJobType(
        cleanerId,
        undefined,
        pageNumber,
        1000
      );

      if (jobTypeData?.success) {
        setData(jobTypeData.data);
        setButtonLoader(false);
        return jobTypeData.data;
      } else {
        setButtonLoader(false);
      }
    } catch (e) {
      setButtonLoader(false);
    }
  };

  const AddAndUpdateJobType = async () => {
    setButtonLoader(true);

    const errors: Record<string, string> = {};
    let invalidFound = false;

    const toCreate = [];
    const toUpdate = [];

    multiJobType.forEach((item) => {
      if (!item.rate || Number(item.rate) === 0) {
        errors[item.job_type] = "Rate must be a valid number";
        invalidFound = true;
        return;
      }

      const existing = data?.find((d) => d.job_type[0] === item.job_type);
      if (existing) {
        toUpdate.push({
          ...item,
          id: existing?.id,
          additional_information:
            information || existing?.additional_information || "",
        });
      } else {
        toCreate.push({
          ...item,
          additional_information: information || "",
        });
      }
    });

    if (invalidFound) {
      setMultiJobTypeErrors(errors);
      setButtonLoader(false);
      return;
    } else {
      setMultiJobTypeErrors({});
    }

    if (toCreate.length === 0 && toUpdate.length === 0) {
      // toast.error("No valid job types with rates to update or create.");
      setButtonLoader(false);
      return;
    }

    try {
      const updatePromise =
        toUpdate.length > 0
          ? updateJobType(toUpdate)
          : Promise.resolve({ success: true });

      const createPromise =
        toCreate.length > 0
          ? createJobtype(toCreate)
          : Promise.resolve({ success: true });

      const [updateResult, createResult] = await Promise.all([
        updatePromise,
        createPromise,
      ]);

      const updatesSuccessful = updateResult?.success;
      const createSuccessful = createResult?.success;

      const bothSucceeded = updatesSuccessful && createSuccessful;
      const bothAttempted = toUpdate.length > 0 || toCreate.length > 0;

      if (bothSucceeded && bothAttempted) {
        const updatedData = await fetchAllJobTypes(userData?.user_id, 1);
        setData(updatedData);
        setPage(1);

        const validChecked =
          updatedData
            ?.filter((item) => Number(item.rate) > 0)
            .map((item) => item.job_type[0]) || [];

        setChecked(validChecked);
        setMultiJobType([]);

        if (page === "popup") {
          dataAddedHandle(true);
        }
        // toast.success("Job types saved successfully.");
      } else if (bothAttempted && (!createSuccessful || !updatesSuccessful)) {
        toast.error("Some job types could not be saved.");
      }
    } catch (err) {
      toast.error("Something went wrong while saving");
    } finally {
      setButtonLoader(false);
    }
  };

  const handleCheckBox = async (id: string) => {
    const cid = data?.find((d) => d.job_type[0] === id)?.id;

    if (checked.includes(id)) {
      if (cid) {
        try {
          setButtonLoader(true);
          const res = await deleteJobType({ id: cid });
          if (res?.success) {
            toast.success("Job type deleted successfully");
            await fetchAllJobTypes(userData?.user_id, 1);
            if (page === "popup") {
              dataAddedHandle(true);
            }
          } else {
            toast.error("Failed to delete job type");
          }
        } catch (e) {
          toast.error("Error occurred while deleting");
        } finally {
          setButtonLoader(false);
        }
      }

      setChecked((prev) => prev.filter((item) => item !== id));
      setMultiJobType((prev) => prev.filter((item) => item.job_type !== id));
    } else {
      setChecked((prev) => [...prev, id]);
      setMultiJobType((prev) => [
        ...prev,
        {
          cleaner_id: userData?.user_id,
          job_type: id,
          rate: 0,
          additional_information: "",
        },
      ]);
    }
  };

  const sortedOptions =
    options?.sort((a, b) => {
      const aAdded = data?.some((d) => d.job_type[0] === a.value);
      const bAdded = data?.some((d) => d.job_type[0] === b.value);
      return aAdded === bAdded ? 0 : aAdded ? -1 : 1;
    }) || [];

  const startIndex = (jobPage - 1) * limit;
  const paginatedOptions = sortedOptions.slice(startIndex, startIndex + limit);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPage) return;
    setPage(newPage);
  };

  useEffect(() => {
    if (options) {
      const total = Math.ceil(options.length / limit);
      settotalPage(total);
    }
  }, [options, limit]);

  useEffect(() => {
    if (userData?.user_id) {
      fetchAllJobTypes(userData?.user_id, 1);
    }
  }, [userData?.user_id]);

  useEffect(() => {
    if (!checkedInitialized && data && options?.length) {
      const matched = options
        .filter((item) => data.some((d) => d.job_type[0] === item.value))
        .map((item) => item.value);

      setChecked(matched);
      setCheckedInitialized(true);
    }
  }, [data, options, checkedInitialized]);

  useEffect(() => {
    if (
      (page === "popup" && type === "put") ||
      (page === "popup" && type === "edit-multiple")
    ) {
      setAllJobs(false);
    }
  }, []);
  useEffect(() => {
    if (userData?.user_id) {
      getInterested(userData?.user_id);
    }
  }, [userData?.user_id]);

  return (
    <ContentWithSpinner loader={loader}>
      {buttonLoader && <LoaderFullScreen />}

      <Checkbox
        divclass="py-3"
        id={"interested"}
        onChange={() => setResInterested(!resInterested)}
        checked={resInterested === false}
        value={resInterested}
        label={
          <FormattedMessage id="CLEANER.JOB.TYPE.RESIDENTIAL.INTERESTED"></FormattedMessage>
        }
      ></Checkbox>

      {!resInterested ? null : !(type === "edit-multiple") ? (
        <form className="mt-5">
          {type !== "put" && (
            <div>
              <label className={`text-normal  text-sm`}>
                Are you available for all types of cleaning jobs?
              </label>
              <div className="flex mt-2">
                <div
                  className={`cursor-pointer text-[#0078ae] border p-1 rounded-2xl w-12 text-center mr-3 ${
                    alljobs
                      ? "bg-gray-200 font-bold  border-gray-600"
                      : " border-gray-300"
                  }`}
                  onClick={() => setAllJobs(true)}
                >
                  Yes
                </div>
                <div
                  className={`cursor-pointer text-[#0078ae] border p-1 rounded-2xl w-12 text-center mr-3 ${
                    !alljobs
                      ? "bg-gray-200 font-bold  border-gray-600"
                      : " border-gray-300"
                  }`}
                  onClick={() => setAllJobs(false)}
                >
                  No
                </div>
              </div>
            </div>
          )}
          {!alljobs && (
            <ReactSelect
              label={jobTypeLabel}
              type="text"
              onChange={(selectedOptions) => setJobType(selectedOptions?.value)}
              placeholder={intl.formatMessage({
                id: "CLEANER.PROFILE.JOBTYPE.INPUT.PLACEHOLDER",
                defaultMessage: "Enter Job Type",
              })}
              error={errors.job_type}
              value={jobType}
              options={selectOptions}
              defaultValue={selectedJobTypeOption}
            />
          )}
          {alljobs && (
            <div className="mt-10">
              <label className={`text-normal  text-sm`}>
                Do you charge the same rate for all jobs?
              </label>
              <div className="flex mt-2">
                <div
                  className={`cursor-pointer border p-1 rounded-2xl w-12 text-[#0078ae] text-center mr-3 ${
                    sameRate
                      ? "bg-gray-200 font-bold  border-gray-600"
                      : " border-gray-300"
                  }`}
                  onClick={() => setSameRate(true)}
                >
                  Yes
                </div>
                <div
                  className={`cursor-pointer text-[#0078ae] border p-1 rounded-2xl w-12 text-center mr-3 ${
                    !sameRate
                      ? "bg-gray-200 font-bold  border-gray-600"
                      : " border-gray-300"
                  }`}
                  onClick={() => setSameRate(false)}
                >
                  No
                </div>
              </div>
            </div>
          )}
          {sameRate || !alljobs ? (
            <Input
              onChange={(e: any) => setRate(e.target.value)}
              error={errors.rate}
              value={values.rate}
              name="rate"
              label={hourlyRateLabel}
              type="number"
              placeholder="$"
            />
          ) : null}

          {alljobs && !sameRate && (
            <>
              {options?.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between w-full space-x-6 py-3"
                >
                  <ReactSelect
                    InputDivClass="w-1/2"
                    label={jobTypeLabel}
                    type="text"
                    placeholder={intl.formatMessage({
                      id: "CLEANER.PROFILE.JOBTYPE.INPUT.PLACEHOLDER",
                      defaultMessage: "Enter Job Type",
                    })}
                    error={errors.job_type}
                    value={item?.value}
                    defaultValue={item}
                    options={[item]}
                  />
                  <Input
                    InputDivClass="w-1/2 h-11"
                    onChange={(e) => {
                      const newRate = e.target.value;
                      const jobTypeValue = item?.value;
                      const cleanerId = userData?.user_id;

                      setMultiJobType((prevItems) => {
                        const existingIndex = prevItems.findIndex(
                          (i) =>
                            i.cleaner_id === cleanerId &&
                            i.job_type === jobTypeValue
                        );

                        if (existingIndex !== -1) {
                          // Update existing entry
                          const updatedItems = [...prevItems];
                          updatedItems[existingIndex] = {
                            ...updatedItems[existingIndex],
                            rate: newRate,
                          };
                          return updatedItems;
                        } else {
                          // Add new entry
                          return [
                            ...prevItems,
                            {
                              cleaner_id: cleanerId,
                              job_type: jobTypeValue,
                              rate: newRate,
                            },
                          ];
                        }
                      });
                    }}
                    error={errors.rate}
                    value={
                      multiJobType.find(
                        (job) =>
                          job?.job_type === item?.value &&
                          job?.cleaner_id === userData?.user_id
                      )?.rate || ""
                    }
                    inputClass="rounded-sm"
                    name="rate"
                    label={hourlyRateLabel}
                    type="number"
                    placeholder="$"
                  />
                </div>
              ))}
            </>
          )}
          {/* <Input
              value={information}
              error={errors.additional_information}
              label={intl.formatMessage({
                id: 'CLEANER.PROFILE.JOBTYPE.ADDITIONALINFORMATION',
                defaultMessage: 'Additional Information'
              })}
              type="text" placeholder={intl.formatMessage({
                id: 'CLEANER.PROFILE.JOBTYPE.ADDITIONALINFORMATION.PLACEHOLDER',
                defaultMessage: 'Enter additional information'
              })}
              name="additional_information"
              onChange={(e: any) => setInformation(e.target.value)}
            ></Input> */}
        </form>
      ) : (
        <>
          {paginatedOptions.map((item) => {
            const isAlreadyAdded = checked?.includes(item?.value);
            const currentRate =
              multiJobType.find((j) => j.job_type === item?.value)?.rate ??
              data?.find((d) => d.job_type[0] === item?.value)?.rate ??
              0;
            return (
              <div className="flex justify-between w-full space-x-6 py-3">
                <div className="flex items-center cursor-pointer select-none mt-6">
                  <div
                    className={`w-6 h-6 flex justify-center items-center rounded-md border-2 
                                  transition-colors duration-200 
                                  ${
                                    isAlreadyAdded
                                      ? "bg-[#ff39b3] border-[#ee33a6]"
                                      : "border-gray-400"
                                  }`}
                    onClick={() => {
                      handleCheckBox(item?.value);
                    }}
                  >
                    {isAlreadyAdded && (
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                <ReactSelect
                  InputDivClass="w-1/2"
                  key={item.value}
                  label={jobTypeLabel}
                  type="text"
                  placeholder={intl.formatMessage({
                    id: "CLEANER.PROFILE.JOBTYPE.INPUT.PLACEHOLDER",
                    defaultMessage: "Enter Job Type",
                  })}
                  error={errors.job_type}
                  value={item?.value}
                  defaultValue={item}
                  options={[item]}
                  disable={!isAlreadyAdded}
                />
                <div className="w-1/2 relative">
                  <Input
                    InputDivClass="h-9"
                    onChange={(e) => {
                      const newRate = e.target.value;
                      const jobTypeValue = item?.value;
                      const cleanerId = userData?.user_id;

                      setMultiJobType((prevItems) => {
                        const existingIndex = prevItems.findIndex(
                          (i) =>
                            i.cleaner_id === cleanerId &&
                            i.job_type === jobTypeValue
                        );

                        if (existingIndex !== -1) {
                          // Update existing entry
                          const updatedItems = [...prevItems];
                          updatedItems[existingIndex] = {
                            ...updatedItems[existingIndex],
                            rate: newRate,
                          };
                          return updatedItems;
                        } else {
                          // Add new entry
                          return [
                            ...prevItems,
                            {
                              cleaner_id: cleanerId,
                              job_type: jobTypeValue,
                              rate: newRate,
                            },
                          ];
                        }
                      });
                    }}
                    error={errors.rate}
                    value={currentRate}
                    name="rate"
                    label={hourlyRateLabel}
                    type="number"
                    placeholder="$"
                    disable={!isAlreadyAdded}
                    inputClass={`rounded-sm ${
                      !isAlreadyAdded ? "!cursor-not-allowed" : ""
                    }`}
                  />
                  {multiJobTypeErrors[item.value] && isAlreadyAdded && (
                    <div className="text-red-600 text-sm absolute -bottom-5">
                      {multiJobTypeErrors[item.value]}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {totalPage > 0 && (
            <div className="mt-4">
              <Pageination
                page={jobPage}
                totalpage={totalPage}
                limit={limit}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </>
      )}

      {page === "popup" &&
      (type === "add" || type === "put" || type === "edit-multiple") ? (
        ""
      ) : (
        <>
          <div className="mt-5 flex space-x-5">
            <ButtonAuth onClick={submitForm} loader={buttonLoader}>
              {editingJobTypeId ? (
                "Update Job Type"
              ) : (
                <FormattedMessage
                  id="REGISTER.BUTTON.SAVEANDCONTINUE"
                  defaultMessage="Save and Continue"
                />
              )}
            </ButtonAuth>
            {editingJobTypeId && (
              <button
                type="button"
                className="mt-5 mb-5 flex h-10 w-32 items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 text-sm font-bold text-gray-700 hover:bg-gray-100"
                onClick={resetJobTypeForm}
              >
                <FontAwesomeIcon icon={faXmark} />
                Cancel
              </button>
            )}
            {resInterested && !alljobs && !editingJobTypeId && (
              <ButtonAuth
                onClick={() => {
                  submitForm();
                  setAddMoreClicked(true);
                }}
                loader={buttonLoader}
              >
                Add More
              </ButtonAuth>
            )}
            {resInterested && data?.length > 0 && !editingJobTypeId && (
              <div
                className="rounded-full text-center
                 bg-[#ff39b3] font-bold
                p-2
                text-white
                w-44
                cursor-pointer mb-5 mt-5
                hover:bg-navy"
                onClick={() => HandleStepper(6)}
              >
                Skip
              </div>
            )}
          </div>
          {resInterested && data?.length > 0 && (
            <div className="mt-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <div className="grid grid-cols-[1.5fr_1fr_96px] bg-gray-50 px-3 py-2 text-[12px] font-bold uppercase text-gray-600">
                <div>Job Type</div>
                <div>Hourly Rate</div>
                <div className="text-right">Actions</div>
              </div>
              {data?.map((item) => (
                <div
                  key={item?.id}
                  className={`grid grid-cols-[1.5fr_1fr_96px] items-center border-t border-gray-100 px-3 py-3 text-[14px] font-medium text-gray-800 ${
                    editingJobTypeId === item?.id ? "bg-blue-50" : ""
                  }`}
                >
                  <div>{getJobTypeDisplayLabel(item?.job_type[0])}</div>
                  <div>{item?.rate ?? 0}</div>
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-[#0078ae] hover:bg-gray-50"
                      onClick={() => handleEditSavedJobType(item)}
                      title="Edit job type"
                    >
                      <FontAwesomeIcon icon={faPencil} />
                    </button>
                    <button
                      type="button"
                      className="flex h-8 w-8 items-center justify-center rounded-md border border-red-200 text-red-600 hover:bg-red-50"
                      onClick={() => handleDeleteSavedJobType(item)}
                      title="Delete job type"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </ContentWithSpinner>
  );
};
export default forwardRef(JobType);
